import type { ComponentChildren } from 'preact'

interface Props {
  label?: string
  children?: ComponentChildren
}

export function Field({ label, children }: Props) {
  return (
    <div class="row">
      {label !== undefined && <label>{label}</label>}
      {children}
    </div>
  )
}
